import { Property } from "../../../../../models/Property";

interface MobileFooterProps {
	setProperty: (val: Property | undefined) => void;
	onViewPdf: (pdfLink: 'brochure' | 'pdf') => void;
	propertyDocumentsDisabled: boolean;
}

export default function MobileFooter({ 
  setProperty, 
  onViewPdf, 
  propertyDocumentsDisabled }: MobileFooterProps) {
	return (
		<div className='mobile-footer'>
			<div className="btn-container">
				<div className='button-group--left'>
					<button
						disabled={propertyDocumentsDisabled}
						style={{ opacity: propertyDocumentsDisabled ? '0.5' : '1' }}
						onClick={() => onViewPdf('brochure')}>
						<span className='esri-icon-review'></span>
						<span>Property Documents</span>
					</button>
					<button onClick={() => onViewPdf('pdf')}>
						<span className='esri-icon-printer'></span>
						<span>Summary PDF</span>
					</button>
				</div>
				<button className="bg-orange no-border" onClick={() => setProperty(undefined)}>CLOSE</button>
			</div>
		</div>
	);
}